export const ipAddress = "https://studelp-server.onrender.com";
// export const ipAddress = "http://localhost:3000";
